import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import { TermsModal } from '../app/TermsModal';
import { accountService, alertService, lockerService } from '../_services';
import { fetchWrapper, history } from '../_helpers';
import metric_smallLockerSelect from "../assets/images/metric_locker-select-small.png";
import metric_largeLockerSelect from "../assets/images/metric_locker-select-large.png";
import metric_stdLockerSelect from "../assets/images/metric_locker-select-standard.png";
import metric_xlargeLockerSelect from "../assets/images/metric_locker-select-x-large.png";
import smallLockerSelect from "../assets/images/locker-select-small.png";
import largeLockerSelect from "../assets/images/locker-select-large.png";
import stdLockerSelect from "../assets/images/locker-select-standard.png";
import xlargeLockerSelect from "../assets/images/locker-select-x-large.png";
import french_stdLockerSelect from "../assets/images/french_locker-select-standard.png";
import french_largeLockerSelect from "../assets/images/french_locker-select-large.png";
import french_xlargeLockerSelect from "../assets/images/french_locker-select-x-large.png";

import { loadStripe } from '@stripe/stripe-js';
import { useTranslation } from 'react-i18next';
import LocaleContext from '../LocaleContext';
import { Account } from '../account';


const standard_img = {
  Small: smallLockerSelect,
  Large: largeLockerSelect,
  Standard: stdLockerSelect,
  Medium: stdLockerSelect,
  'X-Large': xlargeLockerSelect,
  'XLarge': xlargeLockerSelect,
  none: ''
}

const metric_img = {
  Small: metric_smallLockerSelect,
  Large: metric_largeLockerSelect,
  Standard: metric_stdLockerSelect,
  Medium: metric_stdLockerSelect,
  'X-Large': metric_xlargeLockerSelect,
  'XLarge': metric_xlargeLockerSelect,
  none: ''
}

const french_img = {
    Standard: french_stdLockerSelect,
    Large: french_largeLockerSelect,
    'X-Large': french_xlargeLockerSelect,
    none: ''
}

function FutureReservation({ history }) {
    const { locale } = useContext(LocaleContext);


    function parkIsClosed(date) {
        //checks the db_config table for rows like "closed_<DATE>"
        //used to provide calendar for Schlitterbahn GI
        if (typeof (accountService.configValue['closed_' + date]) != 'undefined') {
            return true;
        } else {
            return false;
        }

    }

    const minRentalDate = accountService.configValue['minRentalDate'];

    function min_date() {
        switch (minRentalDate) {
            case "TODAY":
                return moment().format("YYYY-MM-DD");
                break;
            case "TOMORROW":
                var tomorrow = moment().add(1, 'days');
                return moment(tomorrow).format("YYYY-MM-DD");
                break;
            default:
                return moment(minRentalDate).format("YYYY-MM-DD");
        }
    }

    function preloadImage(url) {
        var img = new Image();
        img.src = url;
        console.log("preloaded" + url);
    }

    const metric_images = (accountService.configValue['metricImages'] == "true") ? true : false;
    var imgs;
    if (locale == 'fr-CA') {
        imgs = french_img;
    } else if (metric_images) {
        imgs = metric_img;
    } else {
        imgs = standard_img;
    }

    const chooselabel = (locale == 'fr-CA') ? "Choisissez cette zone" : "Choose this Area";

    //lockerAreas is a semicolon delimted list of area names
    const { t } = useTranslation();
    const lockerAreas = accountService.configValue['lockerAreas'].split(";");
    const [showTerms, setShowTerms] = useState(false);
    const [date, setDate] = useState(min_date());
    const [options, setOptions] = useState([]);
    const [soldOut, setSoldOut] = useState(false);

    const [lockerArea, setLockerArea] = useState((lockerAreas.length == 1) ? lockerAreas[0] : "");
    const [selectedArea, setSelectedArea] = useState("");
    const [areaSelectImage, setAreaSelectImage] = useState(undefined);
    const [showAreaSelect, setShowAreaSelect] = useState((lockerArea.length == 1) ? false : true);

    const [showLockerSelect, setShowLockerSelect] = useState((lockerAreas.length == 1) ? true : false);
    const [lockerSelectImage, setLockerSelectImage] = useState(imgs['X-Large']);
    const [lockerType, setLockerType] = useState("X-Large");
    const [parkClosed, setParkClosed] = useState(false);


    const stripeKey = accountService.configValue['stripePublicKey'];
    const stripePromise = loadStripe(stripeKey);
    const maxRentalDate = accountService.configValue['maxRentalDate'];
    const skipFee = (accountService.configValue['skipConvenienceCharge'] == 'true')
    const convenienceChargeCents = parseInt(accountService.configValue['convenienceChargeCents']);


  let initialValues = {
      area: lockerArea,
      lockerType: lockerType,
      startDate: date,
      acceptTerms: false
    };
    useEffect(() => {
        setLockerSelectImage(imgs[lockerType]);
    }, [locale])
  
  async function fetchData() {
    setShowLockerSelect(false);

    if (lockerAreas.length == 1) {
      setLockerArea(lockerAreas[0]);
      setShowLockerSelect(true);
    }

    console.log("FETCH INVENTORY " + date);
    if (parkIsClosed(date)) {
      setParkClosed(true);
      
    } else {
      setParkClosed(false);
    }

    const data = await lockerService.getLockerInventory(date, lockerArea);
    console.log(data);
    if (lockerArea != "") {
      setShowLockerSelect(true);
      var all_sold_out = true;
      for (var index = 0; index < data.length; index++) {
        if (data[index].availability > 0) {
          all_sold_out = false;
          break
        }
      }
      setSoldOut(all_sold_out);
    }

    setOptions(options => data);

    var ttyp = "";
    //on load, or when the lockerType is not available in the data, reset the size display image.
    if (imgs[lockerType] == "" || (data.length != 0 && (data.filter(item => (item.availability > 0)).filter(row => row.name == lockerType)).length == 0)) {
      var first_type = data.filter(item => (item.availability > 0)).sort((a, b) => (a.price > b.price) ? 1 : -1)[0]?.name;

      ttyp = imgs[first_type || 'none'];
      setLockerType(first_type);
    } else {
      ttyp = imgs[lockerType];
    }

    setLockerSelectImage(ttyp);

  }

  useEffect(() => {

    for (var key in imgs) {
      preloadImage(imgs[key]);
    }

  }, []);

  useEffect(() => {
    fetchData();
  }, [lockerArea, date]);

  //array arg is "dependencies" for useEffect - empty means run once on component mount
  //when this includes date, the select stops working to include date as well

  

  function max_date() {
    if (moment(maxRentalDate, "YYYY-MM-DD", true).isValid()) {
      return moment(maxRentalDate).format("YYYY-MM-DD");
    } else {
      return moment().add(parseInt(maxRentalDate), 'days').format("YYYY-MM-DD");
    }
  }

  let validationSchema = Yup.object().shape({
    lockerType: Yup.string()
      .required(t('Choose a Locker Type')),
    startDate: Yup.date()
      .required(t('Reservation Date is required')),
    acceptTerms: Yup.bool()
      .oneOf([true], t('reservation.agreeError'))
  });

  async function stripe_redir(lockerType, reservationId) {

    const stripe = await stripePromise;

    // Call your backend to create the Checkout Session

    const response = await fetchWrapper.post('/create-checkout-session',
      {
        lockerType: lockerType,
        reservation_id: reservationId
      }
    );

    const session = await response;

    // When the customer clicks on the button, redirect them to Checkout.
    const result = await stripe.redirectToCheckout({
      sessionId: session.id,
    });

    if (result.error) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `result.error.message`.
      alertService.error(result.error.message);
    }
  }

  function onSubmit(fields, { setStatus, setSubmitting }) {
    setStatus();
    accountService.addReservation(fields)
      .then((data) => {
        //alertService.info('Reservation Step 2: Payment');
        stripe_redir(fields.lockerType, data.id);
      })
      .catch(error => {
        setSubmitting(false);
        alertService.error(error);
      });

  }

  const handleClose = () => {
    setShowTerms(false);
  };
  const handleShow = () => {
    setShowTerms(true);
  };

  const handleSizeChange = (e) => {
    setLockerType(e.target.value);
    setLockerSelectImage(imgs[e.target.value] ? imgs[e.target.value] : imgs['none']);
  };
  const handleDateChange = (e) => {
    setDate(e.target.value);
  };
  const handleSelectAreaChange = (e) => {
    setSelectedArea(e.target.value);
    setLockerArea(e.target.value);
    setShowAreaSelect(false);
  }
  const handleAreaChange = (e) => {
      setLockerArea(selectedArea);
      setShowAreaSelect(false);
  };

    const handleReturnToSelectArea = (e) => {
        setLockerArea("");
        setAreaSelectImage(undefined);
        setShowAreaSelect(true);
    }

  return (

    <div className="card m-3">
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize={true}>
        {({ errors, touched, isSubmitting, handleChange }) => (
          <Form>
            <div className="card-header">
              <h1 className="bold-tx">{t('Rent a Locker')}</h1>
              <h5 className="mar-bot-0">{t('Select')} {(lockerAreas.length != 1) ? t("Area, Size and ") : t("Size and ")}{t('Date')}</h5>
            </div>
            <div className="card-body">

              {parkClosed &&
                <div className="form-row">
                  <div className="form-group">
                    <p> {t('reservation.closed')} </p>
                  </div>
                </div>
              }

              {!parkClosed &&
                <>
                  <div className="form-row">
                    {(lockerAreas.length != 1) && showAreaSelect ? (
                      <div className="form-group col-6">
                        <label>{t('Select Area')}</label>
                        <Field as="select"
                          name="Area"
                          onChange={(e) => { handleChange(e); handleSelectAreaChange(e, this); }}
                          className={'form-control' + (errors.Area && touched.Area ? ' is-invalid' : '')} >
                          <option key={'default'} value={""}>{t('Select Area')} . . .</option>
                          {
                            lockerAreas.map((val) =>
                              <option key={val} value={val}> {val}</option>
                            )
                          }
                        </Field>
                        <ErrorMessage name="Area" component="div" className="invalid-feedback" />
                        <></>
 
                      </div>
                    ) : (<></>)
                    }
                  </div>
                </>
              }

              {(showLockerSelect && !soldOut) ?
                (
                  <>
                    {!parkClosed &&
                      <>
                        <div className="form-row">

                          <div className="form-group col-6">
                            <label>{t('Select Size')}</label>
                            <Field as="select"
                              name="lockerType"
                              onChange={(e) => { handleChange(e); handleSizeChange(e, this); }}
                              className={'form-control' + (errors.lockerType && touched.lockerType ? ' is-invalid' : '')} >
                              {
                                 options.filter(item => (item.availability > 0))
                                         .sort((a, b) => (a.price > b.price) ? 1 : -1)
                                         .map((option) => {
                                             if (skipFee) {
                                                return <option key={option.name} value={option.name}> {t(option.name)}    -    ${(((option.price * 100)) / 100)}</option>
                                             }
                                             else {
                                                 return <option key={option.name} value={option.name}> {t(option.name)}    -    ${(((option.price * 100) + convenienceChargeCents) / 100)}</option>
                                             }
                                         })
                              }
                            </Field>
                            <ErrorMessage name="lockerType" component="div" className="invalid-feedback" />
                          </div>

                        </div>

                        <div className="form-row">
                          <div className="form-group">
                            <img className="locker-select" src={lockerSelectImage} />
                          </div>
                        </div>
                      </>
                    }

                    <div className="form-row">
                      <div className="form-group col-6">
                        <label>{t('Select Date')}</label>
                        <Field
                          onChange={(e) => { handleChange(e); handleDateChange(e, this); }}
                          name="startDate" max={max_date()} min={min_date()} type="date" className={'form-control' + (errors.startDate && touched.startDate ? ' is-invalid' : '')} />
                        <ErrorMessage name="startDate" component="div" className="invalid-feedback" />
                      </div>
                    </div>

                    {!parkClosed && 
                    <>
                    <div className="form-row rent-agree-marg">
                      <div className="form-group form-check col-6" style={{ 'paddingLeft': 30 + 'px', 'paddingRight': '0' }} >
                        <Field type="checkbox" name="acceptTerms" id="acceptTerms" className={'form-check-input ' + (errors.acceptTerms && touched.acceptTerms ? ' is-invalid' : '')} />
                        <label htmlFor="acceptTerms" className="form-check-label">{t('reservations.agree')} <Link to="#" onClick={handleShow} >{t('Rental Agreement')}.</Link>
                          <br />
                          {t('reservations.salesFinal')}
                        </label>
                        <ErrorMessage name="acceptTerms" component="div" className="invalid-feedback" />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <button type="submit" id="toPayment" disabled={isSubmitting} className="btn btn-primary">
                          {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                  {t('Step 2 - Payment')}
                              </button>
                      </div>
                    </div>
                    </>
                    }
                  </>
                )
                :
                ((!showLockerSelect) ? (
                  <>
                  </>
                ) :
                  (
                    <>
                      <div className="form-row">
                        <div className="form-group">
                          <p> {t('reservations.soldOut')} </p>
                        </div>
                      </div>
                    {(lockerAreas.length != 1) &&
                      <div className="form-row">
                        <div className="form-group">
                          <button type="submit" onClick={(e) => {handleReturnToSelectArea(e)}} disabled={isSubmitting} className="btn btn-primary">
                            {t('Select Area')}
                          </button>
                        </div>
                      </div>}
                    </>
                  )
                )
              }
            </div>
            <div>
              <h3 className="card-header cust-footer">
                <Link to="login" className="btn btn-link">{t('Cancel')}</Link>
              </h3>
            </div>
          </Form>
        )}
      </Formik>
      <TermsModal show={showTerms} onHide={handleClose} />
    </div>

  );
}

export { FutureReservation }; 